"use client";

import type { FC } from "react";

import type { ArticleAEMData } from "@jti/fe-common";
import { QueryClient, QueryClientProvider } from "@jti/rest-api";
import { BlogListing as BlogUI } from "@jti/ui/components/BlogListing";

import type { blogInputs } from "./Blog.builder";

export type BlogBuilderProps = BuilderComponentProps<typeof blogInputs> & {
  articles: ArticleAEMData[];
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

export const Blog: FC<BlogBuilderProps> = ({
  disableLoyalty,
  disableTiers,
  title,
  errorMessage,
  articles = [],
  reversed,
}) => {
  return (
    <QueryClientProvider client={queryClient}>
      <BlogUI
        articles={articles}
        path=""
        errorMessage={errorMessage}
        title={title}
        disableLoyalty={disableLoyalty}
        disableTiers={disableTiers}
        reversed={reversed}
      />
    </QueryClientProvider>
  );
};
